export function resetHeight() {
    const sections1 = Array.from(document.querySelectorAll('.pack-row'));
    const sections2 = Array.from(document.querySelectorAll('.plan-wrapper .row'));
    const sections3 = Array.from(document.querySelectorAll('.combo-carousel'));

    const resetHeightForElements = (sections: Element[], selector: string) => {
        sections.forEach(section => {
            const dynamic = Array.from(section.querySelectorAll(`.item ${selector}`));

            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                if (closestItem?.classList.contains('featured')) {
                    return; // Skip featured items
                }
                (element as HTMLElement).style.height = 'auto';
            });

            let maxHeight = 0;
            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                if (closestItem?.classList.contains('featured')) {
                    return; // Skip featured items
                }
                const paragraphHeight = (element as HTMLElement).offsetHeight;
                maxHeight = Math.max(maxHeight, paragraphHeight);
            });

            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                if (closestItem?.classList.contains('featured')) {
                    return; // Skip featured items
                }
                (element as HTMLElement).style.height = `${maxHeight}px`;
            });
        });
    };

    resetHeightForElements(sections1, '.top');
    resetHeightForElements(sections2, '.top');
    resetHeightForElements(sections2, '.includes');
    resetHeightForElements(sections1, '.includes');
    resetHeightForElements(sections1, 'small');
    resetHeightForElements(sections2, 'small');
    resetHeightForElements(sections1, '.price-wrap');
    resetHeightForElements(sections2, '.price-wrap');
    resetHeightForElements(sections3, 'h4');
}